export const defaultContentAreaRange = 'xxxs';
const rangeMinimums = {
  xxs: 272,
  xs: 328,
  sm: 553,
  md: 653,
  lg: 933,
  xl: 1153,
  xxl: 1293
};
/** Converts a container width (in pixels) to a content area range  */

export const rangeFromWidth = width => {
  if (width >= rangeMinimums.xxl) {
    return 'xxl';
  }

  if (width >= rangeMinimums.xl) {
    return 'xl';
  }

  if (width >= rangeMinimums.lg) {
    return 'lg';
  }

  if (width >= rangeMinimums.md) {
    return 'md';
  }

  if (width >= rangeMinimums.sm) {
    return 'sm';
  }

  if (width >= rangeMinimums.xs) {
    return 'xs';
  }

  if (width >= rangeMinimums.xxs) {
    return 'xxs';
  }

  return 'xxxs';
};
//# sourceMappingURL=content-area.js.map